import {findDeleteButtons} from "../util/confirmDelete";
import filterText from "../nav/filterText";
import sortTable from "../nav/sortTable";
import percentCircle from "../components/percentCircle";
import handleSectionsPage from './sections';
import {_id} from "../util/dom";
import RichEditor from "quill";

let allRichEditors = { };

export default function handleAdminPage(path) {
    findDeleteButtons();
    filterText();
    sortTable();
    percentCircle();
    activateRollingReviewModals(true);
    watchForRollingReviews();

    if (path.match(/\/ratings\/(new|edit)/)) {
        // append colours to the colour list
        const colours = $('select[name=colour] option');
        colours.each(function () {
            const circle = $('<div>').addClass('rating-circle inline-block mright-10');
            circle.addClass(this.getAttribute('value'));
            $(this).prepend(circle);
        });
    }
    else if(~path.indexOf('/admin/assessments/versions/preview')) {
        handleSectionsPage(path);
    } else if (~path.indexOf('/admin/assessments/versions/')) {
        richEditorsInit();
    }
}

function richEditorsInit() {
    let richEditorEls = document.querySelectorAll('.rich-editor');
    for (let richEditorEl of richEditorEls) {
        let richEditor = new RichEditor(richEditorEl, {
            theme: 'snow'
        });

        let sectionTitle = richEditorEl.getAttribute('data-section-title');
        let sectionTitleDelta = JSON.parse(richEditorEl.getAttribute('data-section-title-delta'));

        // check if it is a valid quill delta
        if (sectionTitleDelta != null && sectionTitleDelta.ops !== undefined) {
            richEditor.setContents(sectionTitleDelta);
        } else
            richEditor.setText(sectionTitle);
        let sectionId = richEditorEl.id.replace('title-', '');
        allRichEditors[sectionId] = richEditor;
    }
    // remove the materialize css on the select for quill editor
    $('select.ql-header').addClass('browser-default');
}

/**
 * This will populate the hidden inputs for section title and section title delta format from rich editor
 * @param {string|number}sectionId
 */
export function populateTitleInputsFromRichEditor(sectionId) {
    let richEditor = allRichEditors[sectionId];

    let titleFromEditor = richEditor.getText();
    let titleDeltaFromEditor = JSON.stringify(richEditor.getContents());

    let hiddenTitle = document.querySelector("#titleView-" + sectionId);
    let hiddenTitleDeltaInput = document.querySelector("#titleDeltaInput-" + sectionId);
    hiddenTitle.setAttribute("value", titleFromEditor);
    hiddenTitleDeltaInput.setAttribute("value", titleDeltaFromEditor);
}

function activateRollingReviewModals(initial) {
    if (initial) {
        $('.modal').modal();
        $('.editRollingReviewButton').click(function(e) {
            const assessmentVersion = $(this).data('assessmentVersion');
            $(_id("edit-rolling-review-modal-" + assessmentVersion)).modal('open');
        });
        $('button[id^="rollingReviewSave-"]').click(function(e) {
            const versionId = $(this).data('versionId');
            saveAndSubmitRollingReview(versionId);
        });
        $('button[id^="rollingReviewAddCycle-"]').click(function(e) {
            const versionId = $(this).data('versionId');
            const cycleNumber = $(this).data('cycle');
            addRollingReviewCycle(versionId, cycleNumber);
        });
        $('a[id^="rollingReviewDeleteCycle-"]').click(function(e) {
            const versionId = $(this).data('versionId');
            const cycleNumber = $(this).data('cycle');
            deleteRollingReviewCycle(versionId, cycleNumber);
        });
        $('input[id^="rollingReviewActiveAll-"]').click(function(e) {
            const cycleNumber = $(this).data('cycle');
            const versionId = $(this).data('versionId');
            addAllSectionsToCycle(versionId, cycleNumber);
        });
        $('input[id^="rollingReviewSectionCheck-"]').click(function(e) {
            const cycleNumber = $(this).data('cycle');
            const versionId = $(this).data('versionId');
            const sectionId = $(this).data('sectionId');
        });
    } else {
        $('a[id^="rollingReviewDeleteCycle-"]').click(function(e) {
            const versionId = $(this).data('versionId');
            const cycleNumber = $(this).data('cycle');
            deleteRollingReviewCycle(versionId, cycleNumber);
        });
        $('input[id^="rollingReviewActiveAll-"]').click(function(e) {
            const cycleNumber = $(this).data('cycle');
            const versionId = $(this).data('versionId');
            addAllSectionsToCycle(versionId, cycleNumber);
        });
        $('input[id^="rollingReviewSectionCheck-"]').click(function(e) {
            const cycleNumber = $(this).data('cycle');
            const versionId = $(this).data('versionId');
            const sectionId = $(this).data('sectionId');
        });
    }
}

function addRollingReviewCycle(versionId, currentCycle) {
    const csrfToken = $('meta[name=csrf-token]').attr('content');
    const versionData = {};
    versionData['id'] = versionId;
    versionData['_token'] = csrfToken;
    ajaxCall('post', '/admin/rolling-review/add-cycle', versionData)
        .done( function(data){
            addCycleToModal(versionId, currentCycle);
        })
        .fail( function(jqXHR) {
            errorRoutine(jqXHR);
        });
}

function deleteRollingReviewCycle(versionId, cycleNumber) {
    const csrfToken = $('meta[name=csrf-token]').attr('content');
    const versionData = {};
    versionData['id'] = versionId;
    versionData['_token'] = csrfToken;
    ajaxCall('post', '/admin/rolling-review/delete-cycle', versionData)
        .done( function(data){
            deleteCycleFromModal(versionId, cycleNumber);
        })
        .fail( function(jqXHR) {
            errorRoutine(jqXHR);
        });
}

function addCycleToModal(versionId, currentCycle) {
    const thisCycle = (parseInt(currentCycle) + 1);

    let newHeader = document.createElement('th');
    newHeader.classList.add('heavy');
    newHeader.dataset.cycle = thisCycle.toString();
    newHeader.innerHTML = "Cycle&nbsp;" + thisCycle;
    newHeader.style.position = "relative";
    newHeader.style.top = "1.2rem";
    let trashButton = document.createElement('a');
    trashButton.classList.add('btn-flat');
    trashButton.classList.add('waves-effect');
    trashButton.id = "rollingReviewDeleteCycle-" + thisCycle;
    trashButton.dataset.versionId = versionId;
    trashButton.dataset.cycle = thisCycle.toString();
    trashButton.style.padding = "0";
    trashButton.style.left = "0.9rem";
    trashButton.style.top = "-0.25rem";
    let trashIcon = document.createElement('i');
    trashIcon.classList.add('material-icons');
    trashIcon.style.fontSize = "15px";
    trashIcon.textContent = "delete";
    trashButton.appendChild(trashIcon);
    newHeader.appendChild(trashButton);
    $('#rollingReviewHeaderRow-' + versionId).children().last().before(newHeader);

    if (parseInt(currentCycle) > 1) {
        $('#rollingReviewDeleteCycle-' + currentCycle).addClass('disabled');
    }

    let newActiveAll = document.createElement('td');
    newActiveAll.dataset.cycle = thisCycle.toString();
    newActiveAll.style.padding = "0";
    newActiveAll.style.textAlign = "center";
    let activeAllInput = document.createElement('input');
    activeAllInput.type = 'checkbox';
    activeAllInput.classList.add('filled-in');
    activeAllInput.classList.add('tableHeader');
    activeAllInput.id = "rollingReviewActiveAll-" + thisCycle;
    activeAllInput.dataset.cycle = thisCycle.toString();
    activeAllInput.dataset.versionId = versionId;
    let activeAllLabel = document.createElement('label');
    activeAllLabel.style.paddingLeft = "50%";
    activeAllLabel.style.top = "0.35rem";
    activeAllLabel.style.left = "3px";
    activeAllLabel.htmlFor = "rollingReviewActiveAll-" + thisCycle;
    newActiveAll.appendChild(activeAllInput);
    newActiveAll.appendChild(activeAllLabel);
    $('#rollingReviewActiveAllRow-' + versionId).children().last().before(newActiveAll);

    $('tr[id^="rollingReviewSubsectionRow-"]').each(function(index){
        const subsectionRow = $(this);
        const sectionId = $(this).data('sectionId');
        let newSubsectionCheck = document.createElement('td');
        newSubsectionCheck.dataset.cycle = thisCycle.toString();
        newSubsectionCheck.style.padding = "0";
        newSubsectionCheck.style.textAlign = "center";
        let subsectionInput = document.createElement('input');
        subsectionInput.type = 'checkbox';
        subsectionInput.classList.add('filled-in');
        subsectionInput.classList.add('tableHeader');
        subsectionInput.id = "rollingReviewSectionCheck-" + sectionId + "-Cycle-" + thisCycle;
        subsectionInput.dataset.sectionId = sectionId;
        subsectionInput.dataset.cycle = thisCycle.toString();
        subsectionInput.dataset.versionId = versionId;
        let subsectionLabel = document.createElement('label');
        subsectionLabel.style.paddingLeft = "50%";
        subsectionLabel.style.top = "0.35rem";
        subsectionLabel.style.left = "3px";
        subsectionLabel.htmlFor = "rollingReviewSectionCheck-" + sectionId + "-Cycle-" + thisCycle;
        newSubsectionCheck.appendChild(subsectionInput);
        newSubsectionCheck.appendChild(subsectionLabel);
        $(this).children().last().before(newSubsectionCheck);
    });

    $('tr[id^="rollingReviewQuestionRow-"]').each(function(index){
        const questionRow = $(this);
        const sectionId = $(this).data('sectionId');
        let newQuestionCheck = document.createElement('td');
        newQuestionCheck.dataset.cycle = thisCycle.toString();
        newQuestionCheck.style.padding = "0";
        newQuestionCheck.style.textAlign = "center";
        let questionInput = document.createElement('input');
        questionInput.type = 'checkbox';
        questionInput.classList.add('filled-in');
        questionInput.classList.add('tableHeader');
        questionInput.id = "rollingReviewSectionCheck-" + sectionId + "-Cycle-" + thisCycle;
        questionInput.dataset.sectionId = sectionId;
        questionInput.dataset.cycle = thisCycle.toString();
        questionInput.dataset.versionId = versionId;
        let questionLabel = document.createElement('label');
        questionLabel.style.paddingLeft = "50%";
        questionLabel.style.top = "0.35rem";
        questionLabel.style.left = "3px";
        questionLabel.htmlFor = "rollingReviewSectionCheck-" + sectionId + "-Cycle-" + thisCycle;
        newQuestionCheck.appendChild(questionInput);
        newQuestionCheck.appendChild(questionLabel);
        $(this).children().last().before(newQuestionCheck);
    });
    $('#rollingReviewAddCycle-' + versionId).data('cycle', thisCycle.toString());
    $('input[id^="rollingReviewActiveAll-"]').unbind('click');
    $('input[id^="rollingReviewSectionCheck-"]').unbind('click');
    $('a[id^="rollingReviewDeleteCycle-"]').unbind('click');
    activateRollingReviewModals(false);
}

function deleteCycleFromModal(versionId, cycleNumber) {
    $('#edit-rolling-review-modal-' + versionId + ' th').each(function() {
        if ($(this).data('cycle') === cycleNumber) {
            $(this).remove();
        }
    });
    $('#edit-rolling-review-modal-' + versionId + ' td').each(function() {
        if ($(this).data('cycle') === cycleNumber) {
            $(this).remove();
        }
    });
    if (cycleNumber > 2) {
        $('#rollingReviewDeleteCycle-' + (parseInt(cycleNumber) - 1)).removeClass('disabled');
    }
    $('#rollingReviewAddCycle-' + versionId).data('cycle', (parseInt(cycleNumber) - 1).toString());
    $('input[id^="rollingReviewActiveAll-"]').unbind('click');
    $('input[id^="rollingReviewSectionCheck-"]').unbind('click');
    $('a[id^="rollingReviewDeleteCycle-"]').unbind('click');
    activateRollingReviewModals(false);
}

function addAllSectionsToCycle(versionId, cycleNumber) {
    const thisCheckbox = $('#rollingReviewActiveAll-' + cycleNumber);
    if (thisCheckbox.prop('checked')) {
        $('#edit-rolling-review-modal-' + versionId + ' input:checkbox').each(function() {
            if ($(this).data('cycle') === cycleNumber) {
                $(this).prop('checked', true);
            }
        });
    } else {
        $('#edit-rolling-review-modal-' + versionId + ' input:checkbox').each(function() {
            if ($(this).data('cycle') === cycleNumber) {
                $(this).prop('checked', false);
            }
        });
    }
}

function saveAndSubmitRollingReview(versionId) {
    const allGood = checkRollingReview(versionId);
    if (allGood) {
        const csrfToken = $('meta[name=csrf-token]').attr('content');
        let sectionData = [];
        $('#edit-rolling-review-modal-' + versionId + ' input:checkbox').each(function() {
            if (!~$(this).attr('id').indexOf('ActiveAll')) {
                if($(this).prop('checked')) {
                    let sectionInfo = {};
                    sectionInfo['sectionId'] = $(this).data('sectionId');
                    sectionInfo['cycleNumber'] = $(this).data('cycle');
                    sectionData.push(sectionInfo);
                }
            }
        });
        let rollingReviewData = {};
        rollingReviewData['_token'] = csrfToken;
        rollingReviewData['versionId'] = versionId;
        rollingReviewData['sectionData'] = sectionData;
        ajaxCall('post', '/admin/rolling-review/save-review', rollingReviewData)
            .done( function(data){
                $(_id("edit-rolling-review-modal-" + versionId)).modal('close');
                location.hash = 'assessmentVersions';
                location.reload();
            })
            .fail(function(jqXHR){
                errorRoutine(jqXHR);
            });
    }
}

function checkRollingReview(versionId) {
    const numCycles = parseInt($('#rollingReviewAddCycle-' + versionId).data('cycle'));
    let errors = 0;
    $('tr[id^="rollingReviewSubsectionRow-"]').each(function(e) {
        let checkedInputs = 0;
        $(this).find('input:checkbox').each(function(e) {
            if ($(this).prop('checked')) {
                checkedInputs = checkedInputs + 1;
            }
        });
        if (checkedInputs === 0) {
            $('#rollingReviewErrorOnSave-' + versionId).text('Section ' + $(this).data('sequenceId') + ' never appears.');
            errors = errors + 1;
            return false;
        }
    });
    $('tr[id^="rollingReviewQuestionRow-"]').each(function(e) {
        let checkedInputs = 0;
        $(this).find('input:checkbox').each(function(e) {
            if ($(this).prop('checked')) {
                checkedInputs = checkedInputs + 1;
            }
        });
        if (checkedInputs === 0) {
            $('#rollingReviewErrorOnSave-' + versionId).text('Section ' + $(this).data('sequenceId') + ' never appears.');
            errors = errors + 1;
            return false;
        }
    });
    for (let i = 1; i <= numCycles; i++) {
        let checkedInputs = 0;
        $('input[id^="rollingReviewSectionCheck-"]').each(function(e) {
            if ($(this).data('cycle') === i) {
                if ($(this).prop('checked')) {
                    checkedInputs = checkedInputs + 1;
                }
            }
        });
        if (checkedInputs === 0) {
            $('#rollingReviewErrorOnSave-' + versionId).text('Cycle ' + i + ' doesn\'t contain any sections.');
            errors = errors + 1;
            return false;
        }
    }
    if (errors === 0) {
        return true;
    }
}

function watchForRollingReviews() {
    const csrfToken = $('meta[name=csrf-token]').attr('content');
    const assessmentData = {};
    assessmentData['_token'] = csrfToken;
    $('select[name="assessment_id"]').change(function(e) {
        if ($(this).val()) {
            assessmentData['id'] = $(this).val();
            ajaxCall('post', '/admin/rolling-review/check-assessment', assessmentData)
                .done( function(data){
                    if (data.result) {
                        $('.newAssessmentStandardRollingReviewOption').show();
                    } else {
                        $('.newAssessmentStandardRollingReviewOption').hide();
                    }
                })
                .fail(function(jqXHR){
                    errorRoutine(jqXHR);
                });
        } else {
            $('.newAssessmentStandardRollingReviewOption').hide();
        }
    });
}

function ajaxCall(type, url, data){
    return $.ajax({
        type: type,
        url: url,
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        processData: true
    });
}

function errorRoutine(jqXHR){
    if(jqXHR.responseJSON == null){
        console.log(jqXHR.responseText);
    }else{
        console.log(jqXHR.responseJSON.message);
    }
}